import { paramsResponsePayloadToModel } from 'core/utils/searchFilters/mappers';
import {
  UpdateUserListModel,
  UpdateUserListPayload,
  UpdateUserListUserModel,
  UpdateUserListUserPayload,
  UserVerifierListResponseModel,
  UserVerifierListResponsePayload,
  UserVerifierModel,
  UserVerifierPayload,
} from '../models';

const updateUserToPayload = (data: UpdateUserListUserModel): UpdateUserListUserPayload => {
  const { id, lang, roles, username, clientId } = data;

  const parsedDefaultData: UpdateUserListUserPayload = {
    id,
    lang,
    username,
    client_id: clientId,
  };

  return !!roles ? { ...parsedDefaultData, roles } : parsedDefaultData;
};

export const updateUserListToPayload = (data: UpdateUserListModel): UpdateUserListPayload => {
  const { userList } = data;

  const transformedUserList = userList.map((item) => updateUserToPayload(item));

  return {
    user_list: transformedUserList,
  };
};

const payloadToUserVerifier = (payload: UserVerifierPayload): UserVerifierModel => {
  const { user_email, user_id } = payload;

  return {
    userId: user_id ?? '',
    userEmail: user_email ?? '',
  };
};

export const payloadToUserVerifierListResponse = (payload: UserVerifierListResponsePayload): UserVerifierListResponseModel => {
  const { data, filters, links, meta } = payload;

  return {
    data: {
      userList: data.user_list.map((item) => payloadToUserVerifier(item)) || [],
    },
    ...paramsResponsePayloadToModel({ links, meta, filters }),
  };
};
